<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-avatar :title="title" v-on="on" style="height: auto">
        <v-icon class="evidence" :color="color">
          mdi-information-outline
        </v-icon>
      </v-avatar>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">{{ titulo }}</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text color="#000">
        <v-row>
          <v-col class="mude">
            <h2 v-if="!isHtml">{{ evidence }}</h2>
            <vue-editor
              v-else
              v-model="evidence"
              label="Evidencia"
              name="evidencia"
              :disabled="true"
              class="editorzinho"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  name: "AppModalShowEvidence",
  components: {
    VueEditor,
  },
  props: {
    evidence: { type: String },
    color: { type: String },
    title: {
      type: String,
      default: "Essa pergunta exige uma evidência. Clique para saber mais",
    },
    isHtml: { type: Boolean, default: false },
    titulo: {
      type: String,
      default: "Evidência(s) Válida(s)",
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
.mude > * {
  color: #000;
  font-weight: 400;
  font-size: 16px;
}
.v-card__text {
  color: #000;
  font-weight: 400;
  font-size: 16px;
}

.editorzinho {
  .ql-toolbar {
    display: none;
  }

  .ql-container {
    border: none !important;
  }

  ul {
    padding: 0 !important;
  }
}
@import "./style.scss";
</style>
